export const states = {
    MENU : 0,
    CHOOSING_DURATION : 1,
    ONGOING_SESSION : 2,
    FINISHED_SESSION : 3,
    FEEDBACK : 4,
    FOOTER_WINDOW : 5
}
export let postersNumber= 0;

export const baseShowsNumber = 48;